import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import settings from "@/scripts/common/settings"
import { addScrollController } from "@/scripts/common/api/scrolltrigger.services"

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

export default class Pin {
    constructor(pin, container, options) {
        this.$pin = pin
        this.$pinContainer = container
        this.scrollController = null
        this.isMobile = window.innerWidth < settings.breakpoints.mobile

        this.scrollPinOptions = {
            trigger: this.$pin,
            endTrigger: this.$pinContainer || this.$pin,
            start: 'top top',
            end: 'bottom bottom',
            pin: this.$pin,
            pinSpacing: this.isMobile ? false : true,
            toggleClass: {
                targets: this.$pin,
                className: `pinned`
            }
        }

        Object.assign(this.scrollPinOptions, options)

        this.init()
    }

    init() {
        this.addPinSCrollController()
    }

    // Options update
    updatePinOption(options) {
        Object.assign(this.scrollPinOptions, options)
    }

    // Callbacks
    refresh() {
        this.scrollController.refresh()
    }

    addPinSCrollController() {
        if (this.scrollController) this.scrollController = null
        this.scrollController = ScrollTrigger.create(this.scrollPinOptions)
        addScrollController(this.scrollController)
    }
}